import {
  Alert,
  Box,
  Card,
  Divider,
  FormGroup,
  Grid,
  Icon,
  RadioGroup,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Badge,
  Tooltip,
  Modal,
} from "@mui/material";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import DataTable from "examples/Tables/DataTable";
import FindInPageOutlinedIcon from "@mui/icons-material/FindInPageOutlined";
import MDBox from "components/MDBox";
import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { green } from "@mui/material/colors";
import Switch from "@mui/material/Switch";
// CheckCircleIcon and ErrorIcon removed (not used)
import { GoogleLogin } from "@react-oauth/google";
import { useNavigate, useLocation } from "react-router-dom";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import QRScanner from "components/QRScanner/QRScanner";
// Reuse styles from verifyByDocument to get the circular icon look
import "../../verify_carnets/modules/verifyByDocument.css";
import MDAlert from "components/Alert";
import EquipmentRegistration from "layouts/user_equipment/modules/EquipmentRegistration";
import EquipmentEdit from "layouts/user_equipment/modules/EquipmentEdit";
import {
  getUserEquipment,
  deleteEquipment,
} from "layouts/user_equipment/services/userEquipmentService";
import { Edit, Delete, MoreVert } from "@mui/icons-material";
import { IconButton, Menu, MenuItem, Chip } from "@mui/material";

// Importar imagen del logo
import logoIUD from "assets/images/logoIUD.png";

export default function VerifyById({
  data,
  onEntryAction,
  onExitAction,
  isAuthenticated = false,
  controllerMessage = "",
  alertType = "",
  isLoading = false,
  initialJoinedState = null,
  joinedStateApplicated = null,
}) {
  const today = new Date();
  const originalCreatedDate = new Date(data?.created);
  const originalExpiresDate = new Date(data?.expires_in);

  // Clonar las fechas para ajustarlas sin modificar las originales
  let adjustedCreatedDate = originalCreatedDate;
  let adjustedExpiresDate = originalExpiresDate;

  let isValid = false;

  if (data?.status !== "Activo") {
    isValid = false;
  } else if (data?.card_type?.name === "Invitado") {
    // Obtener las horas a restar/sumar
    const checkInTimeStr = data?.data_source_file?.data_source?.check_in_time;
    const checkOutTimeStr = data?.data_source_file?.data_source?.check_out_time;

    // Ajustar la fecha de creación
    if (checkInTimeStr) {
      const [h, m, s] = checkInTimeStr.split(":").map(Number);
      adjustedCreatedDate = new Date(originalCreatedDate);
      adjustedCreatedDate.setHours(adjustedCreatedDate.getHours() - h);
      adjustedCreatedDate.setMinutes(adjustedCreatedDate.getMinutes() - m);
      adjustedCreatedDate.setSeconds(adjustedCreatedDate.getSeconds() - s);
    }

    // Ajustar la fecha de expiración
    if (checkOutTimeStr) {
      const [h, m, s] = checkOutTimeStr.split(":").map(Number);
      adjustedExpiresDate = new Date(originalExpiresDate);
      adjustedExpiresDate.setHours(adjustedExpiresDate.getHours() + h);
      adjustedExpiresDate.setMinutes(adjustedExpiresDate.getMinutes() + m);
      adjustedExpiresDate.setSeconds(adjustedExpiresDate.getSeconds() + s);
    }

    // Verificar si la fecha actual está dentro del rango ajustado
    isValid = adjustedCreatedDate <= today && adjustedExpiresDate >= today;
  } else {
    // Verificar si la fecha actual está dentro del rango original
    isValid = originalCreatedDate <= today && originalExpiresDate >= today;
  }

  let errorMessage = "";
  if (data?.status !== "Activo") {
    errorMessage = `Este carnet se encuentra ${
      data?.status?.toLowerCase() || "inactivo"
    } y no puede ser utilizado`;
  } else if (adjustedCreatedDate > today) {
    if (data?.card_type?.name === "Invitado") {
      errorMessage = "El evento aún no ha comenzado. Regresa en la fecha y hora programada";
    } else {
      errorMessage = "Este carnet aún no está activo. Verifica la fecha de inicio de vigencia";
    }
  } else if (adjustedExpiresDate < today) {
    if (data?.card_type?.name === "Invitado") {
      errorMessage = "El evento ya ha finalizado. Este carnet ya no es válido";
    } else {
      errorMessage = "Este carnet ha expirado. Contacta al administrador para renovarlo";
    }
  }

  // Estados para Google Auth
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [isAlert, setIsAlert] = useState(false);
  const [typeAlert, setTypeAlert] = useState("");
  const [showGoogleLogin, setShowGoogleLogin] = useState(false);
  const [showEquipmentModal, setShowEquipmentModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingEquipmentId, setEditingEquipmentId] = useState(null);
  const [equipment, setEquipment] = useState([]);
  const [loadingEquipment, setLoadingEquipment] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [filters, setFilters] = useState({ type: "", brand: "", search: "" });
  const navigate = useNavigate();
  const location = useLocation();

  // Cargar equipos cuando hay un cardUserId válido
  useEffect(() => {
    if (isAuthenticated && data?.card_user?.id) {
      loadEquipment();
    }
  }, [isAuthenticated, data?.card_user?.id]);

  const loadEquipment = async () => {
    try {
      setLoadingEquipment(true);
      const result = await getUserEquipment(data?.card_user?.id);
      if (result.success) {
        setEquipment(result.data);
      }
    } catch (error) {
      console.error("Error al cargar equipos:", error);
    } finally {
      setLoadingEquipment(false);
    }
  };
  const shouldShowButtons =
    isAuthenticated &&
    (data?.card_type?.name === "Invitado" || data?.card_type?.name === "Visitante");
  const isDisabled = !isValid;

  // Función para obtener color del estado
  const getStatusColor = () => {
    if (isValid && data?.status === "Activo") return "success";
    if (data?.status !== "Activo") return "error"; // Cualquier estado que no sea "Activo"
    if (adjustedCreatedDate > today) return "warning";
    if (adjustedExpiresDate < today) return "error";
    return "default";
  };

  // Función para obtener texto del estado
  const getStatusText = () => {
    if (isValid && data?.status === "Activo") return "VÁLIDO";
    if (data?.status !== "Activo") return data?.status?.toUpperCase() || "INACTIVO"; // Muestra el estado real
    if (adjustedCreatedDate > today) return "PENDIENTE";
    if (adjustedExpiresDate < today) return "EXPIRADO";
    return data?.status?.toUpperCase() || "DESCONOCIDO";
  };

  // Funciones para Google Auth
  const handleAlertClick = (message) => {
    setAlertMessage(message);
    setShowAlert(true);
  };

  const handleDialogClose = () => {
    setShowAlert(false);
  };

  const handleAlert = (type, message) => {
    setTypeAlert(type);
    setAlertMessage(message || "");
    setIsAlert(true);
  };

  // Manejo del éxito en Google Login
  const handleGoogleSuccess = async (credentialResponse) => {
    const idToken = credentialResponse.credential;

    if (!idToken) {
      console.error("Error: No se recibió el ID Token de Google.");
      handleAlertClick("Error en la autenticación con Google.");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/users/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id_token: idToken }),
      });

      const dataResponse = await response.json();

      if (response.ok && dataResponse.payload.token) {
        localStorage.setItem("token", dataResponse.payload.token);
        localStorage.setItem("roleId", dataResponse.payload.roleId);
        localStorage.setItem("permissions", JSON.stringify(dataResponse.payload.permissions));
        localStorage.setItem("user_id", dataResponse.payload.user.id);

        window.location.reload();
      } else {
        handleAlertClick(dataResponse.error || "No estás autorizado para ingresar.");
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      handleAlertClick("Error en la conexión con el servidor.");
    } finally {
      setShowGoogleLogin(false);
    }
  };

  const handleGoogleError = () => {
    handleAlertClick("Error en la autenticación con Google. Inténtalo de nuevo.");
    setShowGoogleLogin(false);
  };

  // Handler que recibe el texto escaneado por el componente QRScanner (vista privada)
  const handleQRDetected = (scannedRaw) => {
    const scanned = (scannedRaw || "").trim();
    console.debug("[VerifyById] QR scanned:", scanned);

    // Solo navegaremos automáticamente para rutas /verify/ (o URLs que apunten a /verify/)
    const verifyMatch = scanned.match(/(\/verify\/[^\/]+\/(?:true|false)\/?)/i);
    if (verifyMatch && verifyMatch[1]) {
      const target = verifyMatch[1];
      // Si ya estamos en una ruta /verify/ y sólo cambia el id, forzar recarga para que se reconsulta
      if (location.pathname.startsWith("/verify/") && target.startsWith("/verify/")) {
        // Use full page navigation to force the app to fetch again
        window.location.href = target;
        return;
      }

      navigate(target);
      return;
    }

    // Si es una URL completa que contiene '/verify/' en su path, extraer y navegar
    if (/^https?:\/\//i.test(scanned)) {
      try {
        const parsed = new URL(scanned);
        if (parsed.pathname && /\/verify\//i.test(parsed.pathname)) {
          const path = parsed.pathname + parsed.search + parsed.hash;
          if (location.pathname.startsWith("/verify/") && path.startsWith("/verify/")) {
            window.location.href = path;
            return;
          }
          navigate(path);
          return;
        }
        // si es una URL que no apunta a /verify, considerarla inválida
        handleAlert("fail", "QR no es válido");
        return;
      } catch (e) {
        // si no se pudo parsear la URL, considerarlo inválido
        handleAlert("fail", "QR no es válido");
        return;
      }
    }

    // Si es una ruta absoluta dentro de la app, permitir solo si contiene /verify/
    if (scanned.startsWith("/")) {
      if (/\/verify\//i.test(scanned)) {
        navigate(scanned);
        return;
      }
      handleAlert("fail", "QR no es válido");
      return;
    }

    // Si parece un id/identificador, navegar a la vista de verificación
    const looksLikeId = /^[0-9A-Za-z\-_.@]{3,}$/.test(scanned);
    if (looksLikeId) {
      const newPath = `/verify/${scanned}/false`;
      if (location.pathname.startsWith("/verify/")) {
        window.location.href = newPath;
        return;
      }
      navigate(newPath);
      return;
    }

    // No coincide con rutas ni parece un identificador útil: mostrar alerta
    handleAlert("fail", "QR no es válido");
  };

  // Vista simplificada para usuarios no autenticados
  const SimpleView = () => {
    if (isLoading && (!data || Object.keys(data).length === 0)) {
      return (
        <MDBox style={{ margin: "10px", padding: "10px" }}>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 3, mt: 1 }}>
            <img
              src={logoIUD}
              alt="Logo IUD"
              style={{ maxWidth: "180px", height: "auto", objectFit: "contain" }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "200px",
            }}
          >
            <Typography variant="h6" sx={{ textAlign: "center", color: "text.secondary", mb: 2 }}>
              Verificando carnet...
            </Typography>
            <Box
              sx={{
                width: 40,
                height: 40,
                border: "4px solid #f3f3f3",
                borderTop: "4px solid #1976d2",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
                "@keyframes spin": {
                  "0%": { transform: "rotate(0deg)" },
                  "100%": { transform: "rotate(360deg)" },
                },
              }}
            />
          </Box>
        </MDBox>
      );
    }

    return (
      <MDBox style={{ margin: "10px", padding: "10px" }}>
        <MDAlert
          isAlert={isAlert}
          setIsAlert={setIsAlert}
          typeAlert={typeAlert}
          message={alertMessage}
        />
        <Box sx={{ display: "flex", justifyContent: "center", mb: 3, mt: 1 }}>
          <img
            src={logoIUD}
            alt="Logo IUD"
            style={{ maxWidth: "180px", height: "auto", objectFit: "contain" }}
          />
        </Box>

        <Typography
          variant="h5"
          component="h2"
          style={{ textAlign: "center", marginBottom: "20px", fontWeight: "bold" }}
        >
          {data?.card_user?.name} {data?.card_user?.lastname}
        </Typography>

        <Grid container spacing={1} sx={{ maxWidth: 600, margin: "0 auto" }}>
          {isValid && (
            <>
              <Grid item xs={12} sm={6} sx={{ textAlign: "center" }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Documento de Identificación
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: "medium", mb: 1 }}>
                  {data?.card_user?.number_id}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} sx={{ textAlign: "center" }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Tipo de Carnet
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: "medium", mb: 1 }}>
                  {data?.card_type?.name}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} sx={{ textAlign: "center" }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Estado
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: "medium", mb: 1 }}>
                  {data?.status}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} sx={{ textAlign: "center" }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Valido hasta
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: "medium", mb: 1 }}>
                  {data?.expires_in
                    ? new Date(data.expires_in).toLocaleDateString()
                    : "No disponible"}
                </Typography>
              </Grid>
            </>
          )}

          <Grid item xs={12}>
            {isValid ? (
              <Alert
                severity="success"
                sx={{
                  mb: 1,
                  ml: -2,
                  mr: 0,
                  px: 3,
                  py: -2,
                  backgroundColor: "white",
                  color: "text.primary",
                  "& .MuiAlert-message": {
                    color: "text.primary",
                    textAlign: "center",
                    width: "100%",
                  },
                  "& .MuiAlert-icon": { color: "green" },
                }}
              >
                <Typography variant="body2" sx={{ textAlign: "center" }}>
                  Este carnet es válido y está vigente para su uso.
                </Typography>
              </Alert>
            ) : (
              <>
                <Alert
                  severity="info"
                  icon={false}
                  sx={{
                    mb: 1,
                    ml: -2,
                    mr: 0,
                    px: 3,
                    py: 2,
                    backgroundColor: "white",
                    color: "text.primary",
                    "& .MuiAlert-message": {
                      color: "text.primary",
                      textAlign: "center",
                      width: "100%",
                    },
                  }}
                >
                  <Typography variant="body2" sx={{ textAlign: "center" }}>
                    No fue posible validar el carnet por el siguiente motivo:
                  </Typography>
                </Alert>
                {controllerMessage && (
                  <Alert
                    severity="error"
                    icon={false}
                    sx={{
                      mb: 1,
                      ml: -2,
                      mr: 0,
                      px: 3,
                      py: 2,
                      backgroundColor: "#d32f2f",
                      color: "white !important",
                      "& .MuiAlert-message": {
                        color: "white !important",
                        textAlign: "center",
                        width: "100%",
                      },
                    }}
                  >
                    <Typography variant="body2" sx={{ textAlign: "center" }}>
                      {controllerMessage}
                    </Typography>
                  </Alert>
                )}
              </>
            )}

            <Typography
              variant="body2"
              sx={{
                textAlign: "center",
                color: "text.secondary",
                mt: 1,
                mb: 1,
                ml: -4,
                mr: 0,
                px: 3,
                py: -2,
              }}
            >
              Si eres administrador del sistema, inicia sesión para conocer más detalles sobre este
              carnet.
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 0 }}>
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={handleGoogleError}
                theme="outline"
                size="large"
                text="signin_with"
                shape="rectangular"
                logo_alignment="left"
              />
            </Box>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  return (
    <>
      {isAuthenticated ? (
        <>
          {isLoading && (!data || Object.keys(data).length === 0) ? (
            <MDBox style={{ margin: "10px", padding: "10px" }}>
              <Box sx={{ display: "flex", justifyContent: "center", mb: 3, mt: 1 }}>
                <img
                  src={logoIUD}
                  alt="Logo IUD"
                  style={{ maxWidth: "180px", height: "auto", objectFit: "contain" }}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "200px",
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    border: "4px solid #f3f3f3",
                    borderTop: "4px solid #3498db",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                    "@keyframes spin": {
                      "0%": { transform: "rotate(0deg)" },
                      "100%": { transform: "rotate(360deg)" },
                    },
                  }}
                />
                <Typography variant="body1" color="textSecondary">
                  Cargando datos del carnet...
                </Typography>
              </Box>
            </MDBox>
          ) : (
            <>
              <br />
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <Typography
                  component="h2"
                  style={{ margin: "auto", textAlign: "center", justifyContent: "center" }}
                >
                  Detalles del usuario:
                </Typography>

                <MDAlert
                  isAlert={isAlert}
                  setIsAlert={setIsAlert}
                  typeAlert={typeAlert}
                  message={alertMessage}
                />

                <Box
                  sx={{
                    width: "100%",
                    mt: 1,
                    display: "flex",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography variant="h6" component="div" sx={{ fontWeight: "bold" }}>
                      {data?.card_user?.name} {data?.card_user?.lastname}
                    </Typography>
                  </Box>

                  {isAuthenticated && (
                    <Box
                      sx={{
                        position: "absolute",
                        right: { xs: 8, sm: 24 },
                        top: "calc(50% + 6px)",
                        transform: "translateY(+10%)",
                        zIndex: 2,
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "white",
                        borderRadius: "50%",
                        padding: { xs: "-1px", sm: "-1px" },
                        boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                      }}
                    >
                      <QRScanner
                        onDetected={handleQRDetected}
                        onShowAlert={handleAlert}
                        iconOnly={true}
                        tooltip="Escanear QR"
                        icon={<CameraAltIcon style={{ color: "#1976d2" }} />}
                      />
                    </Box>
                  )}
                </Box>
              </Box>

              <br />
              <MDBox style={{ margin: "20px" }}>
                {/* Estado del carnet como badge */}
                <Box sx={{ display: "flex", justifyContent: "center", mb: 4 }}>
                  <Alert severity={getStatusColor()}>
                    <Typography variant="body2" sx={{ textAlign: "center", fontWeight: "bold" }}>
                      {getStatusText()}
                    </Typography>
                  </Alert>
                  {/*<Badge
                    badgeContent={getStatusText()}
                    color={getStatusColor()}
                    sx={{
                      "& .MuiBadge-badge": {
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        height: "48px",
                        minWidth: "120px",
                        borderRadius: "24px",
                        padding: "0 16px",
                        cursor: "default",
                        pointerEvents: "none",
                      },
                    }}
                  >
                    <Box sx={{ width: 1, height: 1 }} />
                  </Badge>*/}
                </Box>

                {/* Alert informativo si el usuario ya ingresó inicialmente */}
                {initialJoinedState === "1" && shouldShowButtons && (
                  <Alert severity="info" sx={{ mb: 3 }} style={{ justifyContent: "center" }}>
                    <Typography variant="body2">
                      Primer ingreso: {data.first_entry_time ? data.first_entry_time.hour : ""}:
                      {data.first_entry_time ? data.first_entry_time.minute : ""} <br />
                      Ultima lectura: {data.last_entry_exit ? data.last_entry_exit.hour : ""}:
                      {data.last_entry_exit ? data.last_entry_exit.minute : ""} -{" "}
                      {data.last_entry_exit ? data.last_entry_exit.status : ""}
                    </Typography>
                  </Alert>
                )}
                {initialJoinedState === "0" &&
                  joinedStateApplicated === "0" &&
                  shouldShowButtons && (
                    <Alert severity="info" sx={{ mb: 3 }} style={{ justifyContent: "center" }}>
                      <Typography variant="body2">
                        Este usuario no ha ingresado al evento.
                      </Typography>
                    </Alert>
                  )}

                {!isValid && (
                  <Alert severity="warning" sx={{ mb: 3 }}>
                    {errorMessage}
                  </Alert>
                )}

                {/* Botones de Entrada y Salida */}
                {shouldShowButtons && (
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      justifyContent: "center",
                      mb: 4,
                      flexDirection: { xs: "column", sm: "row" },
                    }}
                  >
                    <MDButton
                      variant="contained"
                      color="success"
                      startIcon={<LoginIcon />}
                      onClick={onEntryAction}
                      disabled={isDisabled}
                      sx={{ width: { xs: "100%", sm: "auto" } }}
                    >
                      Registrar Entrada
                    </MDButton>
                    <MDButton
                      variant="contained"
                      color="error"
                      startIcon={<LogoutIcon />}
                      onClick={onExitAction}
                      disabled={isDisabled}
                      sx={{ width: { xs: "100%", sm: "auto" } }}
                    >
                      Registrar Salida
                    </MDButton>
                  </Box>
                )}

                {/* Fechas de vigencia - Responsive */}
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                    gap: 2,
                    mb: 3,
                  }}
                >
                  <Box>
                    <Typography color="black" fontWeight={500} sx={{ mb: 1 }}>
                      Fecha de Inicio
                    </Typography>
                    <MDInput
                      disabled={true}
                      type="datetime-local"
                      value={data?.created || ""}
                      sx={{ width: "100%" }}
                    />
                  </Box>
                  <Box>
                    <Typography color="black" fontWeight={500} sx={{ mb: 1 }}>
                      Fecha de Fin
                    </Typography>
                    <MDInput
                      disabled={true}
                      type="datetime-local"
                      value={data?.expires_in || ""}
                      sx={{ width: "100%" }}
                    />
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                    gap: 2,
                    mb: 2,
                  }}
                >
                  <Box>
                    <Typography color="black" fontWeight={500} sx={{ mb: 1 }}>
                      Documento de Identificación
                    </Typography>
                    <MDInput
                      disabled={true}
                      value={data?.card_user?.number_id || ""}
                      sx={{ width: "100%" }}
                    />
                  </Box>
                  <Box>
                    <Typography color="black" fontWeight={500} sx={{ mb: 1 }}>
                      Tipo de Carnet
                    </Typography>
                    <MDInput
                      disabled={true}
                      value={data?.card_type?.name || ""}
                      sx={{ width: "100%" }}
                    />
                  </Box>

                  {data?.card_type?.name === "Invitado" && (
                    <>
                      <Box>
                        <Typography color={"black"} fontWeight={500}>
                          Condición especial
                        </Typography>
                        <Tooltip
                          title={data?.card_user?.special_condition || ""}
                          arrow
                          disableHoverListener={false}
                          disableFocusListener={false}
                          disableTouchListener={false}
                          enterTouchDelay={0}
                          leaveTouchDelay={3000}
                        >
                          <Box>
                            <MDInput
                              disabled={true}
                              style={{
                                marginTop: "5px",
                                "& .MuiInputBase-input": {
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                },
                              }}
                              label=""
                              value={data?.card_user?.special_condition || ""}
                              sx={{ width: "100%" }}
                            />
                          </Box>
                        </Tooltip>
                      </Box>

                      <Box>
                        <Typography color={"black"} fontWeight={500}>
                          Lugar de origen
                        </Typography>
                        <Tooltip
                          title={data?.card_user?.origin_place || ""}
                          arrow
                          disableHoverListener={false}
                          disableFocusListener={false}
                          disableTouchListener={false}
                          enterTouchDelay={0}
                          leaveTouchDelay={3000}
                        >
                          <Box>
                            <MDInput
                              disabled={true}
                              style={{
                                marginTop: "5px",
                                "& .MuiInputBase-input": {
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                },
                              }}
                              label=""
                              value={data?.card_user?.origin_place || ""}
                              sx={{ width: "100%" }}
                            />
                          </Box>
                        </Tooltip>
                      </Box>
                    </>
                  )}
                </Box>

                {/* Evento (solo para invitados) */}
                {data?.card_type?.name === "Invitado" && data?.data_source_file && (
                  <Box sx={{ mb: 2 }}>
                    <Typography color="black" fontWeight={500} sx={{ mb: 1 }}>
                      Evento
                    </Typography>
                    <MDInput
                      disabled={true}
                      multiline
                      value={data?.data_source_file?.data_source?.source_name || ""}
                      sx={{ width: "100%" }}
                    />
                  </Box>
                )}
              </MDBox>
              <Divider variant="middle" />

              {/* Sección de equipos para usuarios autenticados */}
              {isAuthenticated && isValid && data?.card_user?.id && (
                <MDBox sx={{ mt: 3, mb: 3, mx: 3 }}>
                  {/* Solo mostrar contenedor de equipos si hay equipos */}
                  {equipment.length > 0 && (
                    <>
                      <MDBox
                        mx={2}
                        mt={-1}
                        py={2}
                        px={2}
                        variant="gradient"
                        bgColor="info"
                        borderRadius="lg"
                        coloredShadow="info"
                        mb={2}
                      >
                        <Typography
                          variant="h6"
                          sx={{ color: "white !important" }}
                          textAlign="center"
                        >
                          Equipos registrados
                        </Typography>
                      </MDBox>

                      {/* Filtros */}
                      <MDBox sx={{ mx: 2, mb: 2 }}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={4}>
                            <MDInput
                              label="Buscar"
                              placeholder="Marca, modelo, serie..."
                              value={filters.search}
                              onChange={(e) =>
                                setFilters((prev) => ({ ...prev, search: e.target.value }))
                              }
                              fullWidth
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <select
                              value={filters.type}
                              onChange={(e) =>
                                setFilters((prev) => ({ ...prev, type: e.target.value }))
                              }
                              style={{
                                width: "100%",
                                padding: "8px 12px",
                                border: "1px solid #d2d6da",
                                borderRadius: "8px",
                                fontSize: "14px",
                              }}
                            >
                              <option value="">Todos los tipos</option>
                              <option value="computador">Computador</option>
                              <option value="tableta">Tableta</option>
                              <option value="otros">Otros</option>
                            </select>
                          </Grid>
                        </Grid>
                      </MDBox>

                      {/* Contenedor de equipos con scroll */}
                      <MDBox
                        sx={{
                          maxHeight: "320px",
                          overflowY: "auto",
                          border: "1px solid #d7d9dd",
                          borderRadius: "12px",
                          p: 2,
                          mb: 3,
                          backgroundColor: "#ffffff",
                          boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                          mx: 2,
                        }}
                      >
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                          <thead>
                            <tr style={{ backgroundColor: "#f8f9fa" }}>
                              <th
                                style={{
                                  padding: "12px",
                                  textAlign: "left",
                                  borderBottom: "1px solid #dee2e6",
                                }}
                              >
                                Imagen
                              </th>
                              <th
                                style={{
                                  padding: "12px",
                                  textAlign: "left",
                                  borderBottom: "1px solid #dee2e6",
                                }}
                              >
                                Tipo
                              </th>
                              <th
                                style={{
                                  padding: "12px",
                                  textAlign: "left",
                                  borderBottom: "1px solid #dee2e6",
                                }}
                              >
                                Marca/Modelo
                              </th>
                              <th
                                style={{
                                  padding: "12px",
                                  textAlign: "left",
                                  borderBottom: "1px solid #dee2e6",
                                }}
                              >
                                Serie
                              </th>
                              <th
                                style={{
                                  padding: "12px",
                                  textAlign: "left",
                                  borderBottom: "1px solid #dee2e6",
                                }}
                              >
                                Color
                              </th>
                              <th
                                style={{
                                  padding: "12px",
                                  textAlign: "center",
                                  borderBottom: "1px solid #dee2e6",
                                }}
                              >
                                Acciones
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {equipment
                              .filter((item) => {
                                const searchTerm = filters.search.toLowerCase();
                                const matchesSearch =
                                  !searchTerm ||
                                  item.brand.toLowerCase().includes(searchTerm) ||
                                  item.model.toLowerCase().includes(searchTerm) ||
                                  item.serial_number.toLowerCase().includes(searchTerm) ||
                                  item.color.toLowerCase().includes(searchTerm);
                                const matchesType = !filters.type || item.type === filters.type;
                                const matchesBrand =
                                  !filters.brand ||
                                  item.brand.toLowerCase().includes(filters.brand.toLowerCase());
                                return matchesSearch && matchesType && matchesBrand;
                              })
                              .map((item) => (
                                <tr key={item.id} style={{ borderBottom: "1px solid #dee2e6" }}>
                                  <td style={{ padding: "12px" }}>
                                    {item.image_path ? (
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: "#1976d2",
                                          cursor: "pointer",
                                          textDecoration: "underline",
                                        }}
                                        onClick={() => {
                                          setSelectedEquipment(item);
                                          setShowImageModal(true);
                                        }}
                                      >
                                        Ver imagen
                                      </Typography>
                                    ) : (
                                      <Typography variant="body2" color="text.secondary">
                                        Sin imagen
                                      </Typography>
                                    )}
                                  </td>
                                  <td style={{ padding: "12px" }}>
                                    <Chip
                                      label={item.type}
                                      size="small"
                                      color="info"
                                      variant="outlined"
                                    />
                                  </td>
                                  <td style={{ padding: "12px" }}>
                                    <Typography variant="body2" fontWeight="medium">
                                      {item.brand} {item.model}
                                    </Typography>
                                  </td>
                                  <td style={{ padding: "12px" }}>
                                    <Typography variant="body2">{item.serial_number}</Typography>
                                  </td>
                                  <td style={{ padding: "12px" }}>
                                    <Typography variant="body2">{item.color}</Typography>
                                  </td>
                                  <td style={{ padding: "12px", textAlign: "center" }}>
                                    <IconButton
                                      size="small"
                                      onClick={() => {
                                        setSelectedEquipment(item);
                                        setEditingEquipmentId(item.id);
                                        setShowEditModal(true);
                                      }}
                                      sx={{ mr: 1 }}
                                    >
                                      <Edit fontSize="small" />
                                    </IconButton>
                                    <IconButton
                                      size="small"
                                      onClick={() => {
                                        setSelectedEquipment(item);
                                        setShowDeleteModal(true);
                                      }}
                                      sx={{ color: "error.main" }}
                                    >
                                      <Delete fontSize="small" />
                                    </IconButton>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </MDBox>
                    </>
                  )}

                  {/* Botón de registro directo - siempre visible */}
                  <MDBox sx={{ display: "flex", justifyContent: "center", mx: 2 }}>
                    <MDButton
                      variant="gradient"
                      color="info"
                      size="large"
                      onClick={() => setShowEquipmentModal(true)}
                    >
                      Registrar Nuevo Equipo
                    </MDButton>
                  </MDBox>
                </MDBox>
              )}
            </>
          )}
        </>
      ) : (
        <SimpleView />
      )}

      <Dialog open={showAlert} onClose={handleDialogClose}>
        <DialogTitle>Información</DialogTitle>
        <DialogContent>
          <DialogContentText>{alertMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleDialogClose} color="primary">
            Cerrar
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Modal de registro directo */}
      <Modal open={showEquipmentModal} onClose={() => setShowEquipmentModal(false)}>
        <Card
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "800px",
            borderRadius: "20px",
            boxShadow: 24,
            p: 4,
            maxHeight: "75vh",
          }}
        >
          <MDBox
            mt={-7}
            color="white"
            bgColor="info"
            variant="gradient"
            borderRadius="lg"
            p={2}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography component="h2">
              Registrar Equipo - {data?.card_user?.name} {data?.card_user?.lastname}
            </Typography>
            <Icon
              sx={{
                fontSize: "2em",
                stroke: "currentColor",
                strokeWidth: "2px",
                cursor: "pointer",
                marginLeft: "auto",
              }}
              onClick={() => setShowEquipmentModal(false)}
            >
              close
            </Icon>
          </MDBox>
          <Divider variant="middle" />
          <div style={{ maxHeight: "55%", overflowY: "auto" }}>
            <EquipmentRegistration
              cardUserId={data?.card_user?.id}
              onSuccess={(equipment) => {
                setShowEquipmentModal(false);
                loadEquipment();
                handleAlert("success", `Equipo ${equipment.type} registrado exitosamente`);
              }}
              onCancel={() => setShowEquipmentModal(false)}
              skipInitialQuestion={true}
            />
          </div>
        </Card>
      </Modal>

      {/* Modal de edición */}
      <Modal open={showEditModal} onClose={() => setShowEditModal(false)}>
        <Card
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "800px",
            borderRadius: "20px",
            boxShadow: 24,
            p: 4,
            maxHeight: "75vh",
          }}
        >
          <MDBox
            mt={-7}
            color="white"
            bgColor="info"
            variant="gradient"
            borderRadius="lg"
            p={2}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography component="h2">
              Editar Equipo - {data?.card_user?.name} {data?.card_user?.lastname}
            </Typography>
            <Icon
              sx={{
                fontSize: "2em",
                stroke: "currentColor",
                strokeWidth: "2px",
                cursor: "pointer",
                marginLeft: "auto",
              }}
              onClick={() => setShowEditModal(false)}
            >
              close
            </Icon>
          </MDBox>
          <Divider variant="middle" />
          <div style={{ maxHeight: "55%", overflowY: "auto" }}>
            <EquipmentEdit
              equipmentId={editingEquipmentId}
              onSuccess={(equipment) => {
                setShowEditModal(false);
                setEditingEquipmentId(null);
                loadEquipment();
                handleAlert("success", `Equipo ${equipment.type} actualizado exitosamente`);
              }}
              onCancel={() => {
                setShowEditModal(false);
                setEditingEquipmentId(null);
              }}
            />
          </div>
        </Card>
      </Modal>

      {/* Menú contextual */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          onClick={() => {
            setEditingEquipmentId(selectedEquipment?.id);
            setShowEditModal(true);
            setAnchorEl(null);
          }}
        >
          <Edit fontSize="small" sx={{ mr: 1 }} />
          Editar
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setShowDeleteModal(true);
          }}
          sx={{ color: "error.main" }}
        >
          <Delete fontSize="small" sx={{ mr: 1 }} />
          Eliminar
        </MenuItem>
      </Menu>

      {/* Modal para ver imagen de equipo */}
      <Modal open={showImageModal && selectedEquipment} onClose={() => setShowImageModal(false)}>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "500px",
            maxWidth: "90vw",
            backgroundColor: "white",
            borderRadius: "12px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
            zIndex: 10000,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "20px",
            cursor: "default",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            style={{
              position: "absolute",
              top: "8px",
              right: "8px",
              background: "#f5f5f5",
              border: "none",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              fontSize: "16px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#666",
            }}
            onClick={() => setShowImageModal(false)}
          >
            ×
          </button>
          {selectedEquipment?.image_path && (
            <img
              src={`${process.env.REACT_APP_BASE_URL}storage/${selectedEquipment.image_path}`}
              alt="Imagen del equipo"
              style={{
                width: "100%",
                maxHeight: "350px",
                objectFit: "contain",
                marginBottom: "10px",
              }}
            />
          )}
          <Typography
            variant="body2"
            sx={{
              color: "#333",
              textAlign: "center",
              fontWeight: "medium",
            }}
          >
            {selectedEquipment?.brand} {selectedEquipment?.model}
          </Typography>
        </div>
      </Modal>

      {/* Modal de confirmación de eliminación */}
      <Modal open={showDeleteModal} onClose={() => setShowDeleteModal(false)}>
        <Card
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "500px",
            borderRadius: "20px",
            boxShadow: 24,
            p: 4,
          }}
        >
          <MDBox
            mt={-7}
            color="white"
            bgColor="info"
            variant="gradient"
            borderRadius="lg"
            p={2}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography component="h2">Confirmar eliminación</Typography>
            <Icon
              sx={{
                fontSize: "2em",
                stroke: "currentColor",
                strokeWidth: "2px",
                cursor: "pointer",
                marginLeft: "auto",
              }}
              onClick={() => setShowDeleteModal(false)}
            >
              close
            </Icon>
          </MDBox>
          <Divider variant="middle" />
          <MDBox p={3}>
            <Typography variant="body1" textAlign="center" mb={3}>
              ¿Estás seguro de que deseas eliminar el equipo {selectedEquipment?.type}{" "}
              {selectedEquipment?.brand} {selectedEquipment?.model}?
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
              <MDButton
                variant="outlined"
                color="secondary"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancelar
              </MDButton>
              <MDButton
                variant="gradient"
                color="error"
                onClick={async () => {
                  try {
                    const result = await deleteEquipment(selectedEquipment?.id);
                    if (result.success === true) {
                      loadEquipment();
                      handleAlert("success", "Equipo eliminado exitosamente");
                    }
                    setShowDeleteModal(false);
                  } catch (error) {
                    handleAlert("fail", error.message);
                    setShowDeleteModal(false);
                  }
                  setShowDeleteModal(false);
                }}
              >
                Eliminar
              </MDButton>
            </Box>
          </MDBox>
        </Card>
      </Modal>
    </>
  );
}
